module.exports = __webpack_public_path__ + "img/anilin.70e7a41d.png";